import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi", "Elektronik Merkezi"];
const payments = ["Nakit", "POS", "Havale", "Cari"];

const allData = [
  { date: "2026-07-17", product: "Kablosuz Mouse", brand: "Logitech", qty: 2, price: 450, total: 900, payment: "Nakit", dealer: "Teknoloji Dünyası" },
  { date: "2026-07-17", product: "Mechanik Klavye", brand: "Corsair", qty: 1, price: 1200, total: 1200, payment: "POS", dealer: "Bilgisayar Plaza" },
  { date: "2026-07-16", product: "27\" Monitör", brand: "Samsung", qty: 3, price: 3500, total: 10500, payment: "Havale", dealer: "Ana Bayi" },
  { date: "2026-07-16", product: "USB-C Hub", brand: "Dell", qty: 5, price: 320, total: 1600, payment: "Nakit", dealer: "Ofis Market" },
  { date: "2026-07-15", product: "Webcam 1080p", brand: "Logitech", qty: 2, price: 680, total: 1360, payment: "Cari", dealer: "Elektronik Merkezi" },
  { date: "2026-07-15", product: "Laptop Standı", brand: "HP", qty: 4, price: 290, total: 1160, payment: "POS", dealer: "Teknoloji Dünyası" },
  { date: "2026-07-14", product: "Masa Lambası LED", brand: "Samsung", qty: 3, price: 180, total: 540, payment: "Nakit", dealer: "Ofis Market" },
  { date: "2026-07-14", product: "Hoparlör 2.1", brand: "Logitech", qty: 1, price: 850, total: 850, payment: "Havale", dealer: "Bilgisayar Plaza" },
];

export default function SimpleSalesReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealer, setDealer] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [search, setSearch] = useState("");

  const data = allData.filter((i) => {
    if (startDate && i.date < startDate) return false;
    if (endDate && i.date > endDate) return false;
    if (dealer && i.dealer !== dealer) return false;
    if (paymentMethod && i.payment !== paymentMethod) return false;
    if (search && !i.product.toLowerCase().includes(search.toLowerCase()) && !i.brand.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const total = data.reduce((sum, d) => sum + d.total, 0);

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-primary-600 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Basit Satış Rapor Kriterleri</span>
          <button
            onClick={() => { setStartDate(""); setEndDate(""); setDealer(""); setPaymentMethod(""); setSearch(""); }}
            className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer"
          >
            Temizle
          </button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              <option value="">Tüm bayiler</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ödeme Yöntemi</label>
            <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              <option value="">Tümü</option>
              {payments.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün / Marka Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Satış Listesi</h2>
        <div className="flex items-center gap-3">
          <span className="text-sm text-foreground-500">{data.length} kayıt</span>
          <span className="text-sm font-semibold text-primary-600">Toplam: ${total.toLocaleString("en-US")}</span>
        </div>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tarih</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Birim</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Toplam</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Ödeme</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Bayi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 text-foreground-500">{item.date}</td>
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.price.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.total.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${item.payment === "Nakit" ? "bg-primary-100 text-primary-700" : item.payment === "POS" ? "bg-accent-100 text-accent-700" : item.payment === "Havale" ? "bg-secondary-100 text-secondary-700" : "bg-foreground-100 text-foreground-700"}`}>
                    {item.payment}
                  </span>
                </td>
                <td className="px-4 py-3 text-foreground-500">{item.dealer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.product}</p>
                <p className="text-xs text-foreground-400">{item.brand} · {item.date}</p>
              </div>
              <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium shrink-0 ${item.payment === "Nakit" ? "bg-primary-100 text-primary-700" : item.payment === "POS" ? "bg-accent-100 text-accent-700" : item.payment === "Havale" ? "bg-secondary-100 text-secondary-700" : "bg-foreground-100 text-foreground-700"}`}>
                {item.payment}
              </span>
            </div>
            <div className="flex items-center justify-between mt-2">
              <p className="text-xs text-foreground-500">{item.dealer}</p>
              <p className="text-sm font-bold text-foreground-900">${item.total.toLocaleString("en-US")}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}